<script setup lang="ts">
import type { SubjectCode } from '~/models/Subject'
import type { GradeCode } from '~/models/Grade'
import { useI18n } from 'vue-i18n'
import { computed, ref, watch } from 'vue'
import { faCopyright } from '@fortawesome/duotone-regular-svg-icons'
import arrayUtils from '~/utils/arrayUtils'
import useProductStore from '~/stores/product'
import Button from '~/components/ui/Button.vue'

const props = defineProps<{
  subjectCode: SubjectCode
  gradeCode: GradeCode
}>()

const { t } = useI18n()
const { truthy } = arrayUtils()
const { getRelatedLocationsByGradeAndSubject } = useProductStore()

const locationIds = ref<number[]>([])

const routeProps = computed(() => ({ name: 'colophon_subject', params: {
  subject: props.subjectCode.toLowerCase(),
  grade: props.gradeCode.toLowerCase(),
} }))

watch(props, async () => {
  if (!(props.gradeCode && props.subjectCode))
    return
  const { colophonLocationIds } = await getRelatedLocationsByGradeAndSubject(props.gradeCode, props.subjectCode)
  locationIds.value = [...colophonLocationIds].filter(truthy<number>)
}, { immediate: true })
</script>

<template>
  <Button
    v-if="locationIds.length > 0"
    v-bind="$attrs"
    variant="ghost"
    :to="routeProps"
  >
    <font-awesome-icon :icon="faCopyright" />
    {{ t('contentTypes.colophon') }}
  </Button>
</template>
